import React, { useEffect, useState } from "react";
import Register from "./Register";
import { useAuth } from "../context/auth-context";
import { useLocation, useNavigate } from "react-router-dom";
import { getDeviceInfo } from "../utils/deviceInfo";
import useAuthAxios from "../utils/baseAxios";
import { API } from "../constants/api";
import { GoArrowLeft } from "react-icons/go";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { errorMessage } from "../utils/errorMessage";
import OtpPin from "./OtpPin";

const TwoFA = () => {
  const { authenticate } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const info = location?.state;
  const [otp, setOtp] = useState<string>("");

  const axiosInstance = useAuthAxios();
  const deviceInfo = getDeviceInfo();

  const handleSignIn = async (data: any) => {
    const response = await axiosInstance.post(API.completeLogin, data);
    return response.data;
  };
  const completeSignIn = useMutation({
    mutationFn: handleSignIn,
    onSuccess: () => {
      toast.success("You are logged in.");

      setTimeout(async () => {
        await authenticate();

        navigate(info.from);
      }, 2000);
    },
    onError: (error: any) => {
      setOtp("");
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });

  const handleSubmit = () => {
    const data = {
      email: info.email,
      password: info.password,
      otp,
      deviceInfo: {
        name: deviceInfo.deviceName,
        uniqueId: deviceInfo.uniqueId,
        os: deviceInfo.operatingSystem?.family,
      },
      rolePass: "user",
    };

    completeSignIn.mutate(data);
  };

  return (
    <div className="w-full mds:w-4/5 md:w-3/5 xxxl:w-[50%] px-6 lgss:px-0 pt-28 pb-20 lgss:pt-16 font-manrope h-full mx-auto flex-col justify-between  items-center  flex">
      <div className="flex flex-col justify-center  items-center   w-full">
        <div className="flex justify-start items-start w-full px-4 lgss:px-8">
          <GoArrowLeft
            onClick={() => {
              navigate(-1);
            }}
            className="text-[#13181B] dark:text-gray-300 cursor-pointer text-[20px]"
          />
        </div>

        <h2 className="text-text_black w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 dark:text-gray-200  font-sora text-2xl text-center font-bold mt-16 lgss:mt-24 lgss:pt-0 ">
          2FA Authentication
          <br />
          (Email)
        </h2>
        <h4 className="font-manrope w-full px-5 lgss:px-0 lgss:w-1/2 text-center xxxl:w-2/5 dark:text-gray-200 text-text_black font-medium text-sm pt-6">
          Kindly input the OTP from your email.
        </h4>
        <form className="mt-6 w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 ">
          <OtpPin otp={otp} setOtp={setOtp} input={6} />

          <h4 className="text-[12px] mt-8  text-[#869AA9] font-bold">
            *If you don't get a mail in your inbox, kindly check your spam or
            promotions tab*
          </h4>
        </form>
      </div>
      <div className="w-full mds:w-[90%] lgss:w-1/2 xxxl:w-2/5 flex flex-col justify-center items-center">
        <button
          onClick={handleSubmit}
          disabled={completeSignIn.isPending}
          className="w-full  h-[52px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-8 lgss:mt-8"
        >
          {completeSignIn.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Verify it's you"
          )}
        </button>
        {info.emailAuth === true && info.authApp === true ? (
          <h4
            className="cursor-pointer text-secondary_button font-bold text-[14px] mt-2"
            onClick={() => {
              navigate("/auth-select", {
                state: {
                  email: info.email,
                  password: info.password,
                  from: info.from,
                  authApp: info.authApp,
                  emailAuth: info.emailAuth,
                },
              });
            }}
          >
            Try another method
          </h4>
        ) : null}
      </div>
    </div>
  );
};
const TwoFaPage = () => (
  <div className="lgss:flex lgss:flex-row h-screen dark:bg-[#13181B]">
    <Register />
    <TwoFA />
  </div>
);
export default TwoFaPage;
